const ValidationModeEnum = {
    Save: 'save',
    Submit: 'submit',
};
export default ValidationModeEnum;
